import ToolRexApp from "./mail_web.jsx";
import AIRexAgent from "./AIRex.jsx";
import LicenseChecker from "./LicenseChecker.jsx";

export default function App() {
  return (
    <>
      <ToolRexApp />
      <LicenseChecker />
      <AIRexAgent />
    </>
  );
}
